export default {"src":"/_next/static/media/stories.ba142417.svg","height":28,"width":26,"blurWidth":0,"blurHeight":0};